module.exports = __webpack_public_path__ + "log-in/img/access-code-example.d62253d9.png";